import { WIDGET_COLORS } from '../constants/colors';

type Props = {
  totalInvestment: string;
  disabled?: boolean;
};

export function RateChip({ totalInvestment, disabled = false }: Props) {
  const rate = Math.round(parseFloat(totalInvestment ?? '0') / 1000);
  if (rate <= 0) return null;

  return (
    <span
      className="inline-flex items-center self-start rounded-full text-[11px] font-bold uppercase tracking-[0.4px]"
      style={{
        background: disabled ? WIDGET_COLORS.gray.bg : WIDGET_COLORS.primaryLight,
        color: disabled ? WIDGET_COLORS.gray.text : WIDGET_COLORS.primary,
        padding: '3px 10px',
        marginTop: '6px',
      }}
    >
      {rate} pts/month
    </span>
  );
}
